<template>
  <div class="addWorks" v-loading.fullscreen.lock="listLoading">
    <el-row class="common-box">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">选择项目</h2>
      </div>
      <div class="common-search ">
        <!--<el-form :inline="true" label-width="70px" class="formInline" size="mini">-->
          <!--<el-form-item label="项目编号" style="width: 250px"> ：{{jobInformation.projectCode}}</el-form-item>-->
          <!--<el-form-item label="项目名称"> : {{jobInformation.projectName}}</el-form-item>-->
        <!--</el-form>-->
        <el-form ref="jobInformation" :model="formData" :inline="true" label-width="90px" class="formInline" size="mini">
          <el-form-item label="项目编号" prop="projectCode">
            <el-input v-model="formData.projectCode" placeholder="请输入项目编号..." :maxlength="18"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="formData.projectName" placeholder="请输入项目名称..." :maxlength="18"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="search-btn" @click="searchData">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table class="limitManagerTable table-expand" style="width: 100%" :data="tableData" size="small"  v-loading="listLoading"
                  element-loading-text="拼命加载中" border header-row-class-name="table-header"
                  @selection-change="handleSelectionChange" ref="multipleTable">
          <el-table-column type="selection" width="50" align="center"
                           v-if="!store_WSIsEdit"></el-table-column>
          <el-table-column type="index" width="50" align="center" v-else></el-table-column>
          <el-table-column prop="projectCode" label="项目编号" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
          <el-table-column prop="startTime" label="项目开始时间" align="center"></el-table-column>
          <el-table-column prop="endTime" label="项目结束时间" align="center"></el-table-column>
          <el-table-column prop="customer" label="客户" align="center"></el-table-column>
        </el-table>
        <!-- 分页 -->
         <el-pagination class="pagination table-pagination"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formData.pageNo"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="formData.pageSize"
                        layout="slot, total, sizes, prev, pager, next, jumper"
                        :total="total">
        </el-pagination>
      </div>
    </el-row>
    <el-row class="common-box" style="min-height:300px;hidden scroll;overflow-x:hidden;margin-bottom:0px;">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">岗位信息</h2>
        <!-- <el-button type="primary" round size="mini" @click="previewPost()">预览岗位</el-button> -->
      </div>
      <div class="common-search">
        <el-row class="formSty">
          <div class="formArea">
            <span class="formLabel"><span class="required">* </span>任务名称</span>
            <el-input v-model="jobInformation.posName" @blur="checkValue(jobInformation.posName,'任务名称')"
                      size="mini" class="formInpsssWid" placeholder="请输入任务名称..." :maxlength="30"
                      :disabled="store_WSIsEdit" style="width:80%"></el-input>
          </div>
          <div class="formArea">
            <span class="formLabel"><span class="required">* </span>性别要求</span>
            <el-select v-model="jobInformation.sexName" size="mini"
                       @change="checkValue(jobInformation.sexName,'性别要求')" class="formInpsssWid"
                       placeholder="请选择..." :clearable="true" :disabled="store_WSIsEdit" style="width:80%">
              <el-option
                  v-for="item in jobInformation.sexOptions"
                  :key="item.id"
                  :label="item.sexName"
                  :value="item.sexName">
              </el-option>
            </el-select>
          </div>
          <!-- <div class="formInpsss">
            <span class="formLabel"><span class="required">* </span>岗位类型</span>
            <el-select v-model="jobInformation.jobType" @change="checkValue(jobInformation.jobType,'岗位类型')"
                       size="mini" class="formInpsssWid" placeholder="请选择..." :clearable="true"
                       :disabled="store_WSIsEdit">
              <el-option
                  v-for="item in jobInformation.jobTypeOptions"
                  :key="item.id"
                  :label="item.signName"
                  :value="item.signName">
              </el-option>
            </el-select>
          </div>
          <div class="formInpsss">
            <span class="formLabel"><span class="required">* </span>项目客户</span>
            <el-input v-model="jobInformation.customer" @blur="checkValue(jobInformation.customer,'项目客户')"
                      :maxlength="20" size="mini" class="formInpsssWid" placeholder="请输入客户/品牌..."
                      :disabled="store_WSIsEdit"></el-input>
          </div>
          <div class="formInpsss">
            <span class="formLabel"><span class="required" :disabled="store_WSIsEdit">* </span>档期类型</span>
            <el-select v-model="jobInformation.dateType"
                       @change="checkValue(jobInformation.dateType,'档期类型')" size="mini"
                       class="formInpsssWid" placeholder="请选择..." :clearable="true"
                       :disabled="store_WSIsEdit">
              <el-option
                  v-for="item in jobInformation.dateTypeOptions"
                  :key="item.id"
                  :label="item.masterName"
                  :value="item.masterName">
              </el-option>
            </el-select>
          </div> -->
        </el-row>
        <el-row class="formSty">
          <div class="formArea" style="width: 100%">
            <span class="formLabel"><span class="required">* </span>任务说明</span>
            <!-- <el-input type="textarea" :rows="4" :maxlength="300"
                      @blur="checkValue(jobInformation.posDetail,'任务说明')" v-model="jobInformation.posDetail"
                      style="width:80%" placeholder="请描述促销员工工作内容和职责..."
                      :disabled="store_WSIsEdit"></el-input> -->
              <label v-for="(item,index) in taskInstructionsSigns1" v-bind:key="index" style="font-size:14px;color:#606266;line-height:27px;padding-right:30px;">
                <input type="checkbox" :value="item" v-model="taskInstructionsSigns1V" style="vertical-align:middle;width:16px;height:16px;margin-right:10px;"
                @change="checkBoxValue(item,'任务说明')">{{item}}
              </label>
              <el-input v-if="taskInstructionsSigns1V.includes('其他')" type="textarea" v-model="jobInformation.otherPosDetail" placeholder="请输入其他说明" :maxlength="500" style="margin: 10px 0 0 102px; width: calc(100% - 150px)"></el-input>
          </div>
          </el-row>
          <el-row class="formSty">
          <div class="formArea" style="width: 100%">
            <span class="formLabel"><span class="required">* </span>任务要求</span>
            <!-- <el-input type="textarea" :rows="4" :maxlength="300"
                      @blur="checkValue(jobInformation.requirements,'任务要求')"
                      v-model="jobInformation.requirements" style="width:80%"
                      placeholder="请描述对促销员的个人基本条件（身高、体重、颜值等等）、工作技能、经验等等要求..."
                      :disabled="store_WSIsEdit"></el-input> -->
              <label v-for="(item,index) in taskInstructionsSigns2" v-bind:key="index" style="font-size:14px;color:#606266;line-height:27px;padding-right:30px;">
                <input type="checkbox" :value="item" v-model="taskInstructionsSigns2V" style="vertical-align:middle;width:16px;height:16px;margin-right:10px;"
                @change="checkBoxValue(item,'任务要求')">{{item}}
              </label>
              <el-input v-if="taskInstructionsSigns2V.includes('其他')" type="textarea" v-model="jobInformation.otherRequirements" placeholder="请输入其他要求" :maxlength="500" style="margin: 10px 0 0 102px; width: calc(100% - 150px)"></el-input>
          </div>
        </el-row>
        <el-row class="formSty">
          <div class="formArea" style="width: 100%">
            <span class="formLabel">服务费说明</span>
            <div style="float: right;width: 90%;">
              <label style="font-size:14px;color:#606266;line-height:27px;padding-right:15px;">
                {{jobInformation.salaryDetail}}
              </label>
            </div>
          </div>
        </el-row>
        <!-- <el-row class="formSty">
          <div class="formArea">
            <span class="formLabel"><span class="required">* </span>薪资待遇</span>
            <el-input type="textarea" :rows="4" :maxlength="300"
                      @blur="checkValue(jobInformation.salaryDetail,'薪资待遇')"
                      v-model="jobInformation.salaryDetail" style="width:80%"
                      placeholder="请输入薪资组成方式、考核和薪资关联..."
                      :disabled="store_WSIsEdit"></el-input>
          </div>
          <div class="formArea">
            <span class="formLabel"><span class="required">* </span>岗位福利</span>
            <el-input type="textarea" :rows="4" :maxlength="300"
                      @blur="checkValue(jobInformation.welfareDetail,'岗位福利')"
                      v-model="jobInformation.welfareDetail" style="width:80%"
                      placeholder="请描述是否有相关的社保福利待遇情况..."
                      :disabled="store_WSIsEdit"></el-input>
          </div>
        </el-row> -->
        <!-- <el-row class="formSty">
          <div class="formArea">
            <span class="formLabel"><span class="required">* </span>岗位薪水</span>
            <div>
              <el-radio v-model="jobInformation.salaryType" :label="1" style="width:30%"
                        :disabled="store_WSIsEdit">
                日薪
                <el-input v-model="jobInformation.daySalary" style="width:130px"
                          :disabled="jobInformation.daySalaryStatus"
                          @blur="checkValue(jobInformation.daySalary,'daySalary')" size="mini"
                          class="formInpsssWid" placeholder="请输入数字(日/元)..."></el-input>
              </el-radio>
              <el-radio v-model="jobInformation.salaryType" :label="2" style="width:30%"
                        :disabled="store_WSIsEdit">
                月薪
                <el-input v-model="jobInformation.monthSalary" style="width:130px"
                          :disabled="jobInformation.monthSalaryStatus"
                          @blur="checkValue(jobInformation.monthSalary,'monthSalary')" size="mini"
                          class="formInpsssWid" placeholder="请输入数字(月/元)..."></el-input>
              </el-radio>
              <el-radio v-model="jobInformation.salaryType" :label="3"
                        :disabled="store_WSIsEdit">面议
              </el-radio>
            </div>
          </div>
          <div class="formInpsss">
            <span class="formLabel"><span class="required">* </span>结算方式</span>
            <el-select v-model="jobInformation.salarySettlement"
                       @change="checkValue(jobInformation.salarySettlement,'结算方式')" size="mini"
                       class="formInpsssWid" placeholder="请选择..." :clearable="true"
                       :disabled="store_WSIsEdit">
              <el-option
                  v-for="item in jobInformation.salarySettlementOptions"
                  :key="item.id"
                  :label="item.masterName"
                  :value="item.masterName">
              </el-option>
            </el-select>
          </div> -->
          <!-- <div class="formInpsss">
            <span class="formLabel"><span class="required">* </span>性别要求</span>
            <el-select v-model="jobInformation.sexName" size="mini"
                       @change="checkValue(jobInformation.sexName,'性别要求')" class="formInpsssWid"
                       placeholder="请选择..." :clearable="true" :disabled="store_WSIsEdit">
              <el-option
                  v-for="item in jobInformation.sexOptions"
                  :key="item.id"
                  :label="item.sexName"
                  :value="item.sexName">
              </el-option>
            </el-select>
          </div>
        </el-row> -->
        <!--
        <el-row class="formSty">
          <div class="formInpsss">
            <span class="formLabel"><span class="required">* </span>联系人姓名</span>
            <el-input v-model="jobInformation.moName" @blur="checkValue(jobInformation.moName,'督导姓名')"
                      size="mini" class="formInpsssWid" placeholder="请输入联系人姓名..." :maxlength="10"
                      :disabled="store_WSIsEdit"></el-input>
          </div>
          <div class="formInpsss">
            <span class="formLabel"><span class="required">* </span>联系人电话</span>
            <el-input v-model="jobInformation.moTel" @blur="checkValue(jobInformation.moTel,'督导电话')"
                      :maxlength="18" size="mini" class="formInpsssWid" placeholder="请输入联系人电话..."
                      :disabled="store_WSIsEdit"></el-input>
          </div>
        </el-row>
        -->
      </div>
    </el-row>
    <!--20181009 应Tina需求，在岗位创建时不用选择标签，默认推送，减少推送人数-->
    <!-- <el-row class="common-box">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">标签推送设定</h2>
      </div>
      <div class="common-box-body" style="padding-top:15px;padding-bottom:0">
        <div class="label-wrap clearfix">
          <div class="floatl label-name" style="margin-left:-20px">
            您已选择
          </div>
          <div class="label-list" style="height: auto;">
            <div v-if="jobInformation.checkboxGroup.length>0" class="industryCategory">
              行业品类:
              <span>{{jobInformation.checkboxGroup.join("、")}}</span>
              <span class="remove-btn" @click="deleteSelfLabel(1)"></span>
            </div>
            <div v-if="jobInformation.checkboxGroup1.length>0" class="industryCategory">
              岗位类型:
              <span>{{jobInformation.checkboxGroup1.join("、")}}</span>
              <span class="remove-btn" @click="deleteSelfLabel(2)"></span>
            </div>
            <div v-if="jobInformation.checkboxGroup2.length>0" class="industryCategory">
              自我标签：
              <span>{{jobInformation.checkboxGroup2.join("、")}}</span>
              <span class="remove-btn" @click="deleteSelfLabel(3)"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top:15px;">
        <div class="label-wrap clearfix">
          <div class="floatl label-name" style="margin-right:-10px">
            行业品类
          </div>
          <div class="label-list">
            <div class="toggle-btn" @click="toggleSlide"></div>
            <div class="label-tabs">
              <el-checkbox-group v-model="jobInformation.checkboxGroup" size="small">
                <el-checkbox @change="showTabs(item,$event)" style="margin-left:10px;"
                             :label="item.signName" v-for="item in tabsData" :key="item.id" border
                             :disabled="store_WSIsEdit" class="paddingL5"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <div style="padding:0;">
        <div class="label-wrap clearfix">
          <div class="floatl label-name" style="margin-right:-10px">
            岗位类型
          </div>
          <div class="label-list clearfix">
            <div class="toggle-btn" @click="toggleSlide"></div>
            <div class="label-tabs">
              <el-checkbox-group v-model="jobInformation.checkboxGroup1" size="small">
                <el-checkbox @change="showTabs(item,$event)" style="margin-left:10px;"
                             :label="item.signName" v-for="item in tabsData2" :key="item.id" border
                             :disabled="store_WSIsEdit"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <div style="padding:0;">
        <div class="label-wrap clearfix">
          <div class="floatl label-name" style="margin-right:-10px">
            自我标签
          </div>
          <div class="label-list clearfix">
            <div class="toggle-btn" @click="toggleSlide"></div>
            <div class="label-tabs">
              <el-checkbox-group v-model="jobInformation.checkboxGroup2" size="small">
                <el-checkbox @change="showTabs(item,$event)" style="margin-left:10px;"
                             :label="item.signName" v-for="item in tabsData3" :key="item.id" border
                             :disabled="store_WSIsEdit"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </el-row> -->
    <!--180713铎哥说用户还没想好这块怎么做，所以先隐藏掉。必填项粉丝会员可见传了个全选，其他未修改，逻辑未注释掉-->
    <!--另外还有岗位管理和选择门店里面有可见范围设定，也都已经注掉-->
    <!--   <el-row class="common-box">
         <div class="common-box-btn clearfix">
           <h2 class="floatl">可见范围设定</h2>
         </div>
         <div class="common-box-body">
           <el-col :span="8" style="margin-bottom:15px">
             <span class="formLabel" style="text-align: left;width:35px">星级</span>
             &lt;!&ndash; <el-input v-model="jobInformation.starRating"  size="mini" class="rangeSetting"  placeholder="请输入岗位名称..."></el-input> &ndash;&gt;
             <el-select v-model="jobInformation.starRating" size="mini" class="rangeSetting1"
                        placeholder="请选择..." :disabled="store_WSIsEdit">
               <el-option
                   v-for="item in jobInformation.starRatingOptions"
                   :key="item.id"
                   :label="item.rankName"
                   :value="item.rankName">
               </el-option>
             </el-select>
             <span style="width:90px;text-align: left;font-size: 14px;color: #606266;position:relative;top:2px;left:5px">级别及以上</span>
           </el-col>
           <el-col :span="8" style="margin-bottom:15px">
             <span class="formLabel pad20">信用分值下限</span>
             <el-input v-model.number="jobInformation.crescoreMin" size="mini" class="rangeSetting"
                       @blur="checkScore" placeholder="分"
                       :disabled="store_WSIsEdit"></el-input>
             &lt;!&ndash;                    上限先注释掉
                                 —
                                 <el-input v-model.number="jobInformation.crescoreMax" size="mini" class="rangeSetting"
                                           @blur="checkScore" placeholder="分"
                                           :disabled="store_WSIsEdit"></el-input>&ndash;&gt;
           </el-col>
           <el-col :span="8" style="margin-bottom:15px">
             &lt;!&ndash; <el-radio-group v-model="jobInformation.searchType" style="margin-top:5px">
                 <el-radio :label="1">粉丝可见</el-radio>
                 <el-radio :label="2">会员可见</el-radio>
             </el-radio-group> &ndash;&gt;
             <span class="formLabel"><span class="required">* </span>账号身份</span>
             <el-checkbox-group v-model="jobInformation.searchType"
                                style="margin-top:5px;width:70%;display:inline-block">
               <el-checkbox label="粉丝" :disabled="store_WSIsEdit"></el-checkbox>
               <el-checkbox label="会员" :disabled="store_WSIsEdit"
                            style="margin-left: 20px"></el-checkbox>
             </el-checkbox-group>
           </el-col>
         </div>
       </el-row>-->
    <el-row style="background-color: #fff;">
      <div class="btns">
        <el-button type="text" @click="cancelCheckStore">取消</el-button>
        <el-button type="primary" class="sureBtn" @click="checkStore">选择门店</el-button>
      </div>
    </el-row>
    <!--岗位预览-->
    <el-dialog
        title="岗位预览"
        :visible.sync="jobPreviewDialog"
        class="quitDialog dialog"
        width="400px"
        :center="true"
        :show-close="false"
    >
      <div class="jobInformation">
        <div class="jobInformationHeader">
          <span class="icon"></span>
          <span class="title">岗位信息</span>
        </div>
        <div class="jobInformationContent">
          <div class="jobType">
            {{jobInformation.posName}}
          </div>
          <div class="salaryTel" style="justify-content:flex-start">岗位薪水 :
            <div v-if="jobInformation.salaryType == 1" style="margin-left: 4px">
              ￥<span class="money">{{jobInformation.daySalary}}</span>
              /天 | {{jobInformation.salarySettlement}}
            </div>
            <div v-else-if="jobInformation.salaryType == 2" style="margin-left: 4px">
              ￥<span class="money">{{jobInformation.monthSalary}}</span>
              /月 | {{jobInformation.salarySettlement}}
            </div>
            <div v-else style="margin-left: 4px">面议</div>
            <!--<div class="tel">联系人电话：{{jobInformation.requirementsTel}}</div>-->
          </div>
          <div class="salaryTel">
            <div>档期类型 : {{jobInformation.dateType}}</div>
          </div>
          <div class="dataJob">
            <div>岗位类型 : {{jobInformation.jobType}}</div>
          </div>
          <div class="requirements">
            <div class="requirementsTitle">任务要求 :</div>
            <div class="requirementsContent">{{jobInformation.requirements}}</div>
          </div>
          <div class="welfareDetail">
            <div class="welfareDetailTitle">岗位福利 :</div>
            <div class="welfareDetailContent">{{jobInformation.welfareDetail}}</div>
          </div>
          <div class="salary">
            <div class="salaryTitle">薪资待遇 :</div>
            <div class="salaryContent">{{jobInformation.salaryDetail}}</div>
          </div>
          <div class="jobDescription">
            <div class="jobDescriptionTitle">任务说明 :</div>
            <div class="jobDescriptionContent">{{jobInformation.posDetail}}</div>
          </div>
        </div>
      </div>
      <!--
      <div class="jobInformation">
        <div class="jobInformationHeader">
          <span class="icon"></span>
          <span class="title">联系人信息</span>
        </div>
        <div class="jobInformationContent">
          <el-row>
            <div class="jobDescription">
              <div class="jobDescriptionTitle" style="width: 80px">联系人姓名 :</div>
              <div class="jobDescriptionContent">{{jobInformation.moName}}</div>
            </div>
          </el-row>
          <el-row>
            <div class="jobDescription">
              <div class="jobDescriptionTitle" style="width: 80px">联系人电话 :</div>
              <div class="jobDescriptionContent">{{jobInformation.moTel}}</div>
            </div>
          </el-row>
        </div>
      </div>
      -->
      <span slot="footer" class="dialog-footer">
		    <el-button class="dialog-btn" type="primary" @click="jobPreviewDialog = false">确 定</el-button>
		  </span>
    </el-dialog>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";
  import utils from '../../../common/js/util.js'

  export default {
    computed:{
      store_WSInfo(){
        return this.$store.state.workSquareInfo
      },
      store_WSIsEdit(){
        return this.$store.state.workSquareIsEdit
      }
    },
    data() {
      return {
        total: null,
        formData: {
          projectCode:null,
          projectName:null,
          pageNo: 1,
          pageSize: 10,
          empId: sessionStorage.getItem('empPk')
        },
        tableData: [],
        allData: [],
        listLoading: false,

        // 岗位信息
        jobInformation: {
          visable: [],
          navState: 2,
          workCode: null,
          projectCode: null,
          projectId: null,
          projectName: null,
          projectIpgId: null,
          posName: null,
          jobType: null,
          signId: null,
          customer: null,
          dateType: null,
          scheduleType: null,
          posDetail: null,
          salaryDetail: null,
          welfareDetail: null,
          requirements: null,
          // moName: null,
          // moTel: null,
          salarySettlement: null,
          salaryCycle: null,
          salaryType: null,
          daySalary: null,
          monthSalary: null,
          salary: null,
          sexName: null,
          sex: null,
          starRating: null,
          rankRuleId: null,
          // crescoreMax: null,
          crescoreMin: null,
          requirementsTel: null,
          checkboxGroup: [],
          checkboxIds: [],
          checkboxGroup1: [],
          checkboxGroup2: [],
          daySalaryStatus: false,
          monthSalaryStatus: false,
          searchType: ['粉丝', '会员'],//因为把整个可见范围设定都隐藏掉了，所以这个必填项传个默认值（全选）
          signIdList: [],
          jobTypeOptions: [],
          dateTypeOptions: [],
          salarySettlementOptions: [],
          sexOptions: [{id: 0, sexName: '不限'}, {id: 1, sexName: '男'}, {id: 2, sexName: '女'},],
          starRatingOptions: [],

          otherPosDetail : '', // 其他任务说明
          otherRequirements: '' // 其他任务要求
        },

        tabsData: [],
        tabsData2: [],
        tabsData3: [],
        multipleSelection: [],
        jobPreviewDialog: false,
        bluring: false,//可以防止提示两次
        hasError: false,//配合bluring，效果更佳
        taskInstructionsSigns1: [],//任务说明
        taskInstructionsSigns1V:[],
        taskInstructionsSigns2: [],//任务要求
        taskInstructionsSigns2V:[],

        proDuringTime: '',//新加的，记录当前选中的项目的duringTime，并传给第二页
      }
    },
    updated() {
      this.disabled()
    },
    mounted() {
      if (this.store_WSInfo != null) {
        this.jobInformation = this.store_WSInfo
        setTimeout(() => {
          this.tableData.map((item, index) => {
            if (item.projectCode == this.store_WSInfo.projectCode) {
              this.$refs.multipleTable.toggleRowSelection(item, true)
            }
          })
        }, 1000)
      }
      this.disabled();
      this.getData();
      this.getDateType();
      this.getSalarySettlement();
      this.getIndustryLabel();
      this.getJobLabel();
      this.getSelfLabel();
      this.getRankLabel();

      this.getTaskInstructionsSigns();
      this.getTaskInstructionsSigns2();

      window.onresize = () => {
        return this.autoResize()
      }
    },
    methods: {
      ...mapMutations(["saveWorkSquareInfo", "workSquareIsEditMethods"]),
      //工具类-弹窗简写
      myNotify(_this, type, normal, or) {
        utils.myNotify(_this, type, normal, or)
      },
      //自动根据标签div的高度，添加或移除下拉小按钮。除此之外，在获取三类标签后，且渲染后，各执行一次。
      autoResize() {
        var arr = document.getElementsByClassName('label-tabs')
        if (arr.length != 0) {
          for (let i = 0; i < arr.length; i++) {//注意如果在引用了此组件 的页面里加了label-tabs类，一定要小心，记得关注这里
            if (arr[i].offsetHeight < 51) {
              arr[i].previousElementSibling.setAttribute("style", "display:none;")
            } else {
              arr[i].previousElementSibling.setAttribute("style", "display:block;")
            }
            if (i == 2) {//因为有的时候arr不足3个，i上限是length，有时候大于3个，所以到3就停止
              break;
            }
          }
        }
      },
      //曾经是有区间上限的，现在暂时不需要，checkScore中的Max不再有意义
      checkScore() {
        if (this.jobInformation.crescoreMin < 0 /*|| this.jobInformation.crescoreMax < 0*/) {
          this.myNotify(this, 'warning', '分值下限不可以小于0')
          this.jobInformation.crescoreMin = null
        } else if (isNaN(this.jobInformation.crescoreMin)) {
          this.myNotify(this, 'warning', '请输入数字类型')
          this.jobInformation.crescoreMin = null
        }
      },
      showTabs(tab, e) {
        let idsArr = this.jobInformation.checkboxIds
        if(e){//如果是选中
          if (idsArr.indexOf(tab.id) < 0) {
            idsArr.push(tab.id)
          }
        }else{//一次仅删一个
          idsArr.map((item, index, arr) => {
            if (item == tab.id) {
              arr.splice(index,1)
            }
          })
        }
      },
      //请求项目数据
      getData() {
        this.allData = [];
        let empPk = sessionStorage.getItem('empPk');
        if (!isNaN(parseInt(empPk))) {
          this.listLoading = true
          this.$http({
            method: "GET",
            url: '/rest/PublishedWork/searchProject2',
            params : {empId: empPk}
          }).then(res => {
            this.allData = res.data;
            this.getDataLocal();
            this.listLoading = false;
          }).catch(res => {
            this.myNotify(this, 'error', '查询失败，请稍后重试')
            this.listLoading = false
          });
        }
      },
      getDataLocal() {
        var result = new Array();
        var projectCode = this.formData.projectCode;
        var projectName = this.formData.projectName;
        // 遍历allData筛选出符合条件的
        this.allData.forEach(function (value, index) {
          if(projectCode && projectCode != '' && value.projectCode.indexOf(projectCode) == -1) {
            return;
          }
          if(projectName && projectName != '' && value.projectName.indexOf(projectName) == -1) {
            return;
          }
          result.push(value);
        });
        this.total = result.length;
        var begin = (this.formData.pageNo - 1) * this.formData.pageSize;
        var end = this.formData.pageNo * this.formData.pageSize > result.length ? result.length : this.formData.pageNo * this.formData.pageSize;
        this.tableData = result.slice(begin, end);

        //如果是从选择门店页面跳转回来，则是带有项目信息的，这时候帮他选中并且配置proDuringTing，不然传参会丢失
        if (this.jobInformation.projectCode) {
          this.tableData.map(item => {
            if (this.jobInformation.projectCode == item.projectCode) {
              this.proDuringTime = {end: item.endTime, start: item.startTime}
              //如果能选就给他选上
              if (!this.store_WSIsEdit) {
                setTimeout(() => {
                  this.$refs.multipleTable.toggleRowSelection(item, true);
                }, 100)
              }
            }
          })
        }
      },
      searchData() {
        this.formData.pageNo = 1;
        this.getDataLocal();
      },
      handleSizeChange(val) {
        this.formData.pageSize = val;
        this.getDataLocal();
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val;
        this.getDataLocal();
      },
      // 获取档期类型list
      getDateType() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchMasterName',
          params: {
            masterCode: 'SCHEDULE_TYPE'
          }
        }).then(res => {
          let data = res.data
          this.jobInformation.dateTypeOptions = data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取结算方式list
      getSalarySettlement() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchMasterName',
          params: {
            masterCode: 'SALARY_CYCLE'
          }
        }).then(res => {
          let data = res.data
          this.jobInformation.salarySettlementOptions = data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取行业类型二级标签
      getIndustryLabel() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchIndustrySignName',
          params: {
            signType: 1,
            signLevel: 2
          }
        }).then(res => {
          let data = res.data
          this.tabsData = data

          setTimeout(() => {
            this.autoResize()//校验一下高度，添加下拉小按钮
          }, 100)
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取岗位标签
      getJobLabel() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchSignName',
          params: {
            signType: 2,
          }
        }).then(res => {
          let data = res.data
          this.tabsData2 = data
          this.jobInformation.jobTypeOptions = data
          setTimeout(() => {
            this.autoResize()//校验一下高度，添加下拉小按钮
          }, 100)
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取自我标签
      getSelfLabel() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchSignName',
          params: {
            signType: 3,
          }
        }).then(res => {
          let data = res.data
          this.tabsData3 = data

          setTimeout(() => {
            this.autoResize()//校验一下高度，添加下拉小按钮
          }, 100)
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取星级
      getRankLabel() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchRankRuleName',
        }).then(res => {
          let data = res.data
          this.jobInformation.starRatingOptions = data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取任务说明
      getTaskInstructionsSigns() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchTaskDescriptionRequirements?type=1',
        }).then(res => {
          let data = res.data
          this.taskInstructionsSigns1 = data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取任务要求
      getTaskInstructionsSigns2() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchTaskDescriptionRequirements?type=2',
        }).then(res => {
          let data = res.data
          this.taskInstructionsSigns2 = data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取项目服务费说明
      getPrjServiceCharge(prjCode) {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchPrjServiceCharge?prjCode=' + prjCode,
        }).then(res => {
          let data = res.data
          this.jobInformation.salaryDetail = data.message
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      handleSelectionChange(rows) {
        if (rows) {
          let length = rows.length
          switch (length) {
            case 0:
              this.jobInformation.projectCode = null
              this.jobInformation.projectName = null
              this.jobInformation.projectIpgId = null
              this.jobInformation.projectId = null
              this.proDuringTime = null
              break;
            case 1:
              this.jobInformation.projectCode = rows[length - 1].projectCode
              this.jobInformation.projectName = rows[length - 1].projectName
              this.jobInformation.projectIpgId = rows[length - 1].projectIpgId
              this.jobInformation.projectId = rows[length - 1].id
              this.proDuringTime = {end: rows[0].endTime, start: rows[0].startTime}
              // 加载服务费说明
              this.getPrjServiceCharge(this.jobInformation.projectCode);
              break;
            case 2:
              this.$refs.multipleTable.clearSelection();
              this.$refs.multipleTable.toggleRowSelection(rows[length - 1], true);
          }
        }
      },
      // 预览岗位
      previewPost() {
        if (!this.hasError || !this.bluring) {
          this.checkValues(this.jobInformation)
        }
        // this.jobPreviewDialog = true
      },
      disabled() {
        //这里绝对不能简化，否则会不断触发updated()然后卡死
        let info = this.jobInformation
        if (info.salaryType == 1) {
          info.daySalaryStatus = false
          info.monthSalaryStatus = true
        } else if (info.salaryType == 2) {
          info.monthSalaryStatus = false
          info.daySalaryStatus = true
        } else{
          info.daySalaryStatus = true
          info.monthSalaryStatus = true
        }
      },
      toggleSlide(event) {
        let target = event.target
        let parentNode = target.parentNode
        if (parentNode.offsetHeight > 40) {
          target.className = 'toggle-btn'
          parentNode.style.height = 40 + 'px'
        } else {
          target.className = 'toggle-btn up'
          parentNode.style.height = 'auto'
        }
      },
      // 清空行业品类所选
      deleteSelfLabel(val) {
        if (this.store_WSIsEdit) {
          return
        } else {
          if (val == 1) {
            let rows = []
            this.jobInformation.checkboxGroup.forEach(item => {
              this.tabsData.forEach((item2, index2, arr2) => {
                if (item == item2.signName) {
                  rows.push(item2)
                }
              })
            })
            rows.forEach(item => {
              this.jobInformation.checkboxIds.forEach((item2, index, arr) => {
                if (item.id == item2) {
                  this.jobInformation.checkboxIds.splice(index, 1)
                }
              })
            })
            this.jobInformation.checkboxGroup = []
          } else if (val == 2) {
            let rows = []
            this.jobInformation.checkboxGroup1.forEach(item => {
              this.tabsData2.forEach((item2, index2, arr2) => {
                if (item == item2.signName) {
                  rows.push(item2)
                }
              })
            })
            rows.forEach(item => {
              this.jobInformation.checkboxIds.forEach((item2, index, arr) => {
                if (item.id == item2) {
                  this.jobInformation.checkboxIds.splice(index, 1)
                }
              })
            })
            this.jobInformation.checkboxGroup1 = []
          } else {
            let rows = []
            this.jobInformation.checkboxGroup2.forEach(item => {
              this.tabsData3.forEach((item2, index2, arr2) => {
                if (item == item2.signName) {
                  rows.push(item2)
                }
              })
            })
            rows.forEach(item => {
              this.jobInformation.checkboxIds.forEach((item2, index, arr) => {
                if (item.id == item2) {
                  this.jobInformation.checkboxIds.splice(index, 1)
                }
              })
            })
            this.jobInformation.checkboxGroup2 = []
          }
        }
      },
      checkStore() {
        // 发布任务时输入的字段去掉，这里赋予默认值，如下
        this.jobInformation.jobType = '0'// 岗位类型：不限
        this.jobInformation.customer = '默认客户'// 服务对象
        this.jobInformation.dateType = '1125'// 空
        this.jobInformation.welfareDetail = '无'// 岗位福利
        this.jobInformation.salaryType = '3'// 薪资要求：面议
        this.jobInformation.salarySettlement = '日结'// 结算方式：日结
        this.jobInformation.salaryCycle = '150'// 结算方式：日结
        if (!this.hasError || !this.bluring) {
          this.$emit('check-store', this.jobInformation, this.proDuringTime);
          this.saveWorkSquareInfo(this.jobInformation)
        }
      },
      cancelCheckStore() {
        this.$confirm('此操作将清空本页未保存的信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //清除store中第一页的数据
          this.saveWorkSquareInfo(null)
          //清除已经发布的状态，然后重新渲染
          this.workSquareIsEditMethods(false)
          this.$emit('resetThis');
        })
      },
      checkBoxValue(val, type) {
        var self = this
        var v = ''
        if (type == '任务说明') {
          v = self.taskInstructionsSigns1V.join(";")
          self.jobInformation.posDetail = v
          if (!self.taskInstructionsSigns1V.includes('其他')) {
            self.jobInformation.otherPosDetail = ''
          }
        }else if(type == '任务要求') {
          v = self.taskInstructionsSigns2V.join(";")
          self.jobInformation.requirements = v
          if (!self.taskInstructionsSigns2V.includes('其他')) {
            self.jobInformation.otherRequirements = ''
          }
        }
      },
      checkValue(val, type) {
        this.bluring = true;
        setTimeout(() => {
          this.bluring = false;
        }, 100)
        let errMag = ''
        if (type == '岗位类型' || type == '档期类型' || type == '结算方式' || type == '性别要求') {
          if (val == null || val == '' || val == undefined) {
            errMag = `请选择${type}!`
          }
        } else if (type == '联系人方式' || type == '督导电话') {
          if (val == null || val == '' || val == undefined) {
            // errMag = `请输入${type}!`
            errMag = '请输入联系人电话！'
          } else if (isNaN(parseInt(val))) {
            errMag = '请输入数字类型!'
          } else if (typeof parseInt(val) !== 'number') {
            errMag = '请输入数字类型!'
          } else if (!(/^1[345789]\d{9}$/.test(val)) && !(/^0[0-9]{2,3}\-([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/).test(val)) {
            errMag = '<span>请输入正确的电话号! <br/> 例：13611111111 或 010-88888888</span>'
          }
        }
        else if (type == 'daySalary' || type == 'monthSalary') {
          if (isNaN(Number(val))) {
            errMag = '岗位薪水请输入数字类型!'
          } else if (Number(val) < 0) {
            errMag = '请输入正确岗位薪水!'
          }
        }
        if (errMag !== '') {
          this.hasError = true;
          this.$notify({
            title: '提示',
            message: errMag,
            type: 'warning',
            dangerouslyUseHTMLString: true,
            message: errMag
          });
        } else {
          this.hasError = false;
        }
      },
      checkValues(jobInformation) {
        let errMag = ''
        if (jobInformation.posName == null || jobInformation.posName == '' || jobInformation.posName == undefined) {
          errMag = "请输入岗位名称";
        } else if (jobInformation.jobType == null || jobInformation.jobType == '' || jobInformation.jobType == undefined) {
          errMag = "请选择岗位类型";
        } else if (jobInformation.customer == null || jobInformation.customer == '' || jobInformation.customer == undefined) {
          errMag = "请输入项目客户";
        } else if (jobInformation.dateType == null || jobInformation.dateType == '' || jobInformation.dateType == undefined) {
          errMag = "请选择档期类型";
        } else if (jobInformation.posDetail == null || jobInformation.posDetail == '' || jobInformation.posDetail == undefined) {
          errMag = "请输入任务说明";
        } else if (jobInformation.salaryDetail == null || jobInformation.salaryDetail == '' || jobInformation.salaryDetail == undefined) {
          errMag = "请输入薪资待遇";
        } else if (jobInformation.welfareDetail == null || jobInformation.welfareDetail == '' || jobInformation.welfareDetail == undefined) {
          errMag = "请输入岗位福利";
        } else if (jobInformation.requirements == null || jobInformation.requirements == '' || jobInformation.requirements == undefined) {
          errMag = "请输入任务要求";
        } else if (jobInformation.salaryType == null) {
          errMag = "请选择岗位薪水";
        } else if (jobInformation.salaryType == 1 && (jobInformation.daySalary != null && jobInformation.daySalary != '' && jobInformation.daySalary != undefined) && (!isNaN(Number(jobInformation.daySalary))) && Number(jobInformation.daySalary) < 0) {
          errMag = "请输入正确岗位薪水";
        } else if (jobInformation.salaryType == 1 && (jobInformation.daySalary == null || jobInformation.daySalary == '' || jobInformation.daySalary == undefined)) {
          errMag = "请输入岗位薪水";
        } else if (jobInformation.salaryType == 1 && (isNaN(Number(jobInformation.daySalary)))) {
          errMag = "岗位薪水请输入数字类型!";
        } else if (jobInformation.salaryType == 2 && (jobInformation.monthSalary != null && jobInformation.monthSalary != '' && jobInformation.monthSalary != undefined) && (!isNaN(Number(jobInformation.monthSalary))) && Number(jobInformation.monthSalary) < 0) {
          errMag = "请输入正确岗位薪水";
        } else if (jobInformation.salaryType == 2 && (jobInformation.monthSalary == null || jobInformation.monthSalary == '' || jobInformation.monthSalary == undefined)) {
          errMag = "请输入岗位薪水";
        } else if (jobInformation.salaryType == 2 && (isNaN(Number(jobInformation.monthSalary)))) {
          errMag = "岗位薪水请输入数字类型!";
        } else if (jobInformation.salarySettlement == null || jobInformation.salarySettlement == '' || jobInformation.salarySettlement == undefined) {
          errMag = "请选择结算方式";
        } else if (jobInformation.sexName == null || jobInformation.sexName == '' || jobInformation.sexName == undefined) {
          errMag = "请选择性别要求";
        // } else if (jobInformation.moName == null || jobInformation.moName == '' || jobInformation.moName == undefined) {
        //   errMag = "请输入联系人姓名";
        // } else if (jobInformation.moTel == null || jobInformation.moTel == '' || jobInformation.moTel == undefined) {
        //   errMag = "请输入联系人电话！";
        // } else if (isNaN(parseInt(jobInformation.moTel))) {
        //   errMag = '请输入数字类型!'
        // } else if (typeof parseInt(jobInformation.moTel) !== 'number') {
        //   errMag = '请输入数字类型!'
        // } else if (!(/^1[345789]\d{9}$/.test(jobInformation.moTel)) && !(/^0[0-9]{2,3}\-([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/).test(jobInformation.moTel)) {
        //   errMag = '<span>请输入正确的电话号! <br/> 例：13611111111 或 010-88888888</span>'
        }/* else if (jobInformation.requirementsTel == null || jobInformation.requirementsTel == '' || jobInformation.requirementsTel == undefined) {
          errMag = "请输入联系人方式";
        } else if (isNaN(parseInt(jobInformation.requirementsTel))) {
          errMag = '请输入数字类型!'
        } else if (typeof parseInt(jobInformation.requirementsTel) !== 'number') {
          errMag = '请输入数字类型!'
        } else if (!(/^1[34578]\d{9}$/.test(jobInformation.requirementsTel)) && !(/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/).test(jobInformation.requirementsTel)) {
          errMag = '<span>请输入正确的电话号! <br/> 例：13611111111 或 010-88888888</span>'
        }*/
        //没必要校验下面这个
        // else if(jobInformation.searchType == null || jobInformation.searchType.length == 0){
        // 	errMag = '请选择粉丝可见或者会员可见！'
        // }
        else {
          this.jobPreviewDialog = true
        }
        if (errMag !== '') {
          this.myNotify(this, 'error', errMag)
        }
      },
    },
  }
</script>

<style scope lang="scss">
  .label-tabs {
    margin-right: 20px;
  }

  .label-tabs .checkbox-group {
    width: 97%;
  }

  .label-tabs .el-checkbox {
    background: #f8f8f8;
    border-color: #eaeaea;
  }

  .label-tabs .el-checkbox.is-bordered.is-checked {
    background: #8299dc;
  }

  .label-tabs .el-checkbox.is-bordered.is-checked .el-checkbox__label {
    color: #fff
  }

  .label-tabs .el-checkbox .el-checkbox__input {
    display: none;
  }

  .btns {
    width: 200px;
    margin: 0 auto;
    .sureBtn {
      width: 80px;
      height: 30px;
      line-height: 6px;
      background: #2c2b79;
      border: none;
      padding: 0;
      margin-left: 35px
    }
  }

  .jobInformation {
    margin: 10px 5px 10px 5px;
    background: #fff;
    border-radius: 10px;
    .jobInformationHeader {
      width: 95%;
      height: 40px;
      border-bottom: 1px solid #f4f4f4;
      line-height: 40px;
      margin: 0 10px;
      .icon {
        display: inline-block;
        width: 2px;
        height: 15px;
        background: #56bff8;
        margin-right: 5px;
        position: relative;
        top: 4px;
      }
      .title {
        color: #333;
      }
    }
    .jobInformationContent {
      padding: 10px 10px 15px 10px;
      .jobType {
        color: #333;
        font-size: 15px;
        margin-bottom: 8px;
      }
      .salaryTel {
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        color: #656565;
        .money {
          font-size: 18px;
          color: #55bff9;
        }
      }
      .dataJob {
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        color: #656565;
        border-bottom: 1px solid #f4f4f4;
        padding-bottom: 5px
      }
      .requirements {
        display: flex;
        // justify-content:flex-start;
        color: #656565;
        margin-top: 5px;
        height: auto;
        .requirementsTitle {
          width: 70px;
        }
        .requirementsContent {
          line-height: 20px;
          margin-top: 2.5px;
          flex: 1
        }
      }
      .welfareDetail {
        display: flex;
        // justify-content:flex-start;
        color: #656565;
        margin-top: 5px;
        .welfareDetailTitle {
          width: 70px;
        }
        .welfareDetailContent {
          line-height: 20px;
          margin-top: 2.5px;
          flex: 1
        }
      }
      .salary {
        display: flex;
        justify-content: flex-start;
        color: #656565;
        margin-top: 5px;
        .salaryTitle {
          width: 70px;
        }
        .salaryContent {
          line-height: 20px;
          margin-top: 2.5px;
          flex: 1
        }
      }
      .jobDescription {
        display: flex;
        // justify-content:flex-start;
        color: #656565;
        margin-top: 5px;
        .jobDescriptionTitle {
          width: 70px;
        }
        .jobDescriptionContent {
          line-height: 20px;
          margin-top: 2.5px;
          flex: 1
        }
      }
    }
  }

  .supervisorInformation {
    margin: 10px 5px 10px 5px;
    background: #fff;
    border-radius: 10px;
    .supervisorInformationHeader {
      width: 95%;
      height: 40px;
      border-bottom: 1px solid #f4f4f4;
      line-height: 40px;
      margin: 0 10px;
      .icon {
        display: inline-block;
        width: 2px;
        height: 15px;
        background: #56bff8;
        margin-right: 5px;
        position: relative;
        top: 4px;
      }
      .title {
        color: #333;
      }
    }
    .supervisorInformationContent {
      padding: 10px 10px 15px 10px;
      .nameTel {
        display: flex;
        justify-content: space-between;
        color: #656565;
      }
    }
  }

  .formLabel.pad20 {
    padding-right: 20px
  }

  .paddingL5 .el-checkbox__label {
    padding-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/workSquare/postJob/addWorks.vue